var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkbox" }, [
    _c("label", { staticClass: "crud-label" }, [
      _c("input", {
        attrs: {
          id: _vm.checkboxData.id,
          type: "checkbox",
          name: _vm.checkboxData.name
        },
        domProps: { checked: _vm.checkboxData.value },
        on: { change: _vm.valueIsChanged }
      }),
      _vm._v(" " + _vm._s(_vm.checkboxData.label) + " "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", { attrs: { src: require("@/drc/assets/images/check.png") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }